<template>
   <div class="firewall-report">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <svg-icon icon-class="firewall" /> Firewall
      </div>

      <el-tabs type="border-card">
        <el-tab-pane label="Transactions">
          <firewall-transactions :project="project"/>
        </el-tab-pane>
        <el-tab-pane label="Summary">
          <firewall-summary :project="project"/>
        </el-tab-pane>
        <el-tab-pane label="Customer">
          <firewall-customer :project="project"/>
        </el-tab-pane>
        <el-tab-pane label="Monitor">
          <firewall-monitor-summary :project="project"/>
        </el-tab-pane>
      </el-tabs>
    </el-card>
   </div>
</template>

<script>
import FirewallTransactions from "./firewall-transactions.vue"
import FirewallSummary from "./firewall-summary.vue"
import FirewallCustomer from "./firewall-customer.vue"
import FirewallMonitorSummary from "./firewall-monitor-summary.vue"
export default {
  props: {
    project: String
  },
  components:{
    FirewallTransactions,
    FirewallSummary,
    FirewallCustomer,
    FirewallMonitorSummary
  },
  data(){
    return {
      
    }
  }
}
</script>

<style>

</style>